import { TotpModal, TotpModalProps } from "@synota-io/synota-shared-ui";
import { useSelf } from "../hooks/useSelf";
import { useMfaEmail } from "../hooks/useMfaEmail";

export const ClientTotpModal = (
  totp: Omit<TotpModalProps, "sendEmail" | "canResend" | "email">,
) => {
  const { self } = useSelf();
  const { sendEmail, canResend } = useMfaEmail();

  return self && totp.open ? (
    <TotpModal sendEmail={sendEmail} canResend={canResend} email={self.email} {...totp} />
  ) : null;
};
